import React from 'react';
import styled from 'styled-components';

const LoaderContainer = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
`;

const LoaderSpinner = styled.div`
    width: 50px;
    height: 50px;
    border: 5px solid #f3f3f3;
    border-top: 5px solid #5a54d1;
    border-radius: 50%;
    animation: spin 1s linear infinite;

    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
`;

const LoaderText = styled.div`
    color: white;
    margin-top: 10px;
    font-size: 16px;
    text-align: center;
`;

const LoaderContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export default function Loader({ show, text = 'Cargando...' }) {
    if (!show) return null;

    return (
        <LoaderContainer>
            <LoaderContent>
                <LoaderSpinner />
                <LoaderText>{text}</LoaderText>
            </LoaderContent>
        </LoaderContainer>
    );
} 